import { render, staticRenderFns } from "./nice-stats-graph.vue?vue&type=template&id=72ed13e4&scoped=true"
import script from "./nice-stats-graph.vue?vue&type=script&lang=js"
export * from "./nice-stats-graph.vue?vue&type=script&lang=js"
import style0 from "./nice-stats-graph.vue?vue&type=style&index=0&id=72ed13e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed13e4",
  null
  
)

export default component.exports